// extracted by mini-css-extract-plugin
module.exports = {"heroContentWrapper":"hero-module--hero-content-wrapper--3-jcU","heroContent":"hero-module--hero-content--18WlK"};